import { Locales } from "@/lib/i18n";
import { segments } from "@/locales/segment";
import { useInstantSearch } from "react-instantsearch";

interface NumberOfHitsProps {
  locale: Locales;
}

export const NumberOfHits = ({ locale }: NumberOfHitsProps) => {
  const { results } = useInstantSearch();

  return (
    <p className="text-sm text-[#9C9C9C]">
      {results.nbHits} {segments[locale || "fr"].product}
    </p>
  );
};
